// extracted by mini-css-extract-plugin
module.exports = {"OrderDate":"OrdersDetails_OrderDate__34pGr","LabelInfo":"OrdersDetails_LabelInfo__3QNVk","TextInfo":"OrdersDetails_TextInfo__cTAQe"};